import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { fmtRelative } from "../lib/utils-app";
import { articleRegion } from "../lib/article-utils";
import Seo from "../components/Seo";
import { Clock } from "lucide-react";

export default function Latest() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/articles?limit=60").then((r) => setItems(r.data.items));
  }, []);

  return (
    <div className="max-w-[1100px] mx-auto px-4 md:px-8 py-10 md:py-14" data-testid="latest-page">
      <Seo
        title="Latest"
        description="Every IndiaODR article, newest first. Arbitration, ODR, award enforcement and institutional news — refreshed continuously."
        path="/latest"
      />
      <div className="eyebrow">The full feed</div>
      <h1 className="font-serif text-[44px] md:text-[56px] mt-2 text-[var(--io-text)]">Latest intelligence</h1>
      <p className="mt-3 text-[15px] text-[var(--io-text-2)] max-w-2xl">Every IndiaODR article, newest first.</p>

      <div className="mt-10 divide-y divide-[var(--io-border)]">
        {items.map((a) => (
          <Link key={a.id} to={`/article/${a.slug}`} className="block py-5 group" data-testid={`latest-${a.slug}`}>
            <div className="flex items-center gap-2 text-[11px] font-mono text-[var(--io-muted)]">
              <span className="text-[var(--io-gold)]">{a.category}</span>
              <span>·</span><span>{articleRegion(a)}</span>
              <span>·</span><span>{fmtRelative(a.published_at)}</span>
              <span>·</span><span className="inline-flex items-center gap-1"><Clock size={10}/> {a.read_minutes || 4}m</span>
              <span>·</span><span>{(a.source_refs || []).length} src</span>
            </div>
            <h3 className="font-serif text-[20px] md:text-[24px] mt-1.5 text-[var(--io-text)] group-hover:text-[var(--io-gold)]">{a.headline}</h3>
            <p className="mt-1.5 text-[14px] text-[var(--io-text-2)] line-clamp-2 max-w-[72ch]">{a.summary}</p>
          </Link>
        ))}
        {items.length === 0 && <div className="py-10 text-[var(--io-muted)]">No articles yet.</div>}
      </div>
    </div>
  );
}
